import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabpune() {



const cardData = {
  keyword: "One Way Cab Pune",
  heading: "Lotus Cab: One Way Cab Pune",

  headingDescription:
    "Lotus Cab provides reliable and affordable One Way Cab service in Pune for customers who want to travel without paying return charges. Whether you need a one-way airport drop, intercity transfer, corporate travel, family relocation, or weekend getaway, our AC sedans, SUVs, luxury cars, and mini buses ensure a safe and comfortable journey. One-way cab booking is the most economical option for Pune to Mumbai, Nashik, Shirdi, Kolhapur, Goa, Bangalore, and other destinations. Our professional chauffeurs ensure punctual pickup from home, office, hotel, airport, or railway station. Vehicles are GPS-enabled, sanitized, and regularly serviced for smooth highway travel. We follow transparent per-kilometer pricing with no hidden charges. With instant online booking and 24/7 support, Lotus Cab guarantees stress-free and budget-friendly one-way travel from Pune.",

  top: "Top Places to Visit from Pune with One Way Cab by Lotus Cab",

  topPlaces: [
    {
      title: "Mumbai",
      description:
        "Mumbai is the most popular destination for one-way cab travel from Pune. Whether for business meetings, airport connections, or leisure trips, one-way travel helps avoid return fare charges. Our AC sedans and SUVs ensure smooth expressway travel. Professional drivers are experienced on Mumbai–Pune highway routes. Ideal for corporate and family trips. Lotus Cab ensures safe, punctual, and economical one-way travel to Mumbai."
    },
    {
      title: "Nashik",
      description:
        "Nashik is known for vineyards and religious sites like Trimbakeshwar Temple. One-way cab service is ideal for pilgrims and weekend travelers. Comfortable AC vehicles ensure relaxed highway travel. SUV options available for families. Budget-friendly per-km pricing provided."
    },
    {
      title: "Shirdi",
      description:
        "Shirdi Sai Baba Temple attracts devotees daily. Many customers prefer one-way drop service for darshan trips. Professional chauffeurs ensure safe and timely arrival. Comfortable seating for elderly passengers. Transparent fare structure offered."
    },
    {
      title: "Kolhapur",
      description:
        "Kolhapur is famous for Mahalaxmi Temple and historical sites. One-way cab service helps travelers avoid double fare costs. SUV and sedan options available. Ideal for pilgrimage and family trips."
    },
    {
      title: "Goa",
      description:
        "Goa is a favorite long-distance travel destination from Pune. One-way cab service is perfect for vacations without return charges. Spacious SUVs and luxury cars available. Comfortable long-distance highway travel ensured."
    },
    {
      title: "Bangalore",
      description:
        "Corporate travelers often book one-way cab from Pune to Bangalore. AC vehicles and experienced drivers ensure smooth interstate travel. Ideal for business relocations and official visits."
    },
    {
      title: "Hyderabad",
      description:
        "Hyderabad is a popular business and family travel destination. One-way cab option reduces cost for long-distance travel. Comfortable seating and highway-ready vehicles available."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a scenic hill station near Pune. One-way cab service is perfect for weekend departures. Professional drivers ensure safe ghat driving. AC vehicles enhance comfort."
    }
  ],

  services: [
    {
      name: "Pune One Way Cab",
      description:
        "Affordable one-way cab service from Pune to major cities. Pay only for single-side distance. Ideal for airport drops, business travel, and relocation. Professional chauffeurs ensure punctual service. Transparent pricing provided before confirmation."
    },
    {
      name: "AC One Way Cab Pune",
      description:
        "Fully air-conditioned vehicles available for comfortable long-distance travel. Suitable for summer travel and family trips."
    },
    {
      name: "Sedan One Way Cab Pune",
      description:
        "Budget-friendly sedan taxis ideal for individuals and small families. Smooth highway performance guaranteed."
    },
    {
      name: "SUV One Way Cab Pune",
      description:
        "Spacious SUV taxis suitable for group travel and extra luggage requirements."
    },
    {
      name: "Luxury One Way Cab Pune",
      description:
        "Premium vehicles for executive and VIP travel with professional chauffeur service."
    },
    {
      name: "Airport Drop One Way Cab Pune",
      description:
        "Reliable airport transfer service without return charges. Timely pickup guaranteed."
    },
    {
      name: "Corporate One Way Cab Pune",
      description:
        "Dedicated corporate one-way taxi service with punctual and professional support."
    },
    {
      name: "Outstation One Way Cab Pune",
      description:
        "Long-distance one-way taxi service for interstate travel with experienced drivers."
    }
  ],

  tableData: [
    ["Pune One Way Cab", "AC One Way Cab Pune"],
    ["Sedan One Way Cab Pune", "SUV One Way Cab Pune"],
    ["Luxury One Way Cab Pune", "Corporate One Way Cab Pune"],
    ["Airport Drop One Way Cab Pune", "Outstation One Way Cab Pune"],
    ["Mini Bus One Way Cab Pune", "Chauffeur Driven One Way Cab Pune"],
    ["Budget One Way Cab Pune", "Same Day One Way Cab Pune"],
    ["Per Km Rate One Way Cab Pune", "Best One Way Cab Pune"],
    ["Group Travel One Way Cab Pune", "Weekend Trip One Way Cab Pune"]
  ],

  whychoose: [
    { WhyChooseheading: "No Return Fare", WhyChoosedescription: "Pay only for one-side travel distance." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-km fare shared before booking." },
    { WhyChooseheading: "Wide Vehicle Options", WhyChoosedescription: "Sedan, SUV, luxury, and mini bus available." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Experienced drivers for long-distance travel." },
    { WhyChooseheading: "Sanitized Vehicles", WhyChoosedescription: "Clean and well-maintained fleet." },
    { WhyChooseheading: "Corporate Travel Support", WhyChoosedescription: "Dedicated business travel solutions." },
    { WhyChooseheading: "Punctual Pickup", WhyChoosedescription: "On-time service from any Pune location." },
    { WhyChooseheading: "24/7 Assistance", WhyChoosedescription: "Round-the-clock customer support." }
  ]
};

const faqData = [
  { question: "What is one-way cab?", answer: "One-way cab allows travel without paying return fare charges." },
  { question: "Are return charges included?", answer: "No, only single-side distance is charged." },
  { question: "Is airport drop available?", answer: "Yes, one-way airport drop service available." },
  { question: "Are SUVs available?", answer: "Yes, spacious SUV options are available." },
  { question: "Is pricing per km transparent?", answer: "Yes, clear fare shared before booking." },
  { question: "Is online booking available?", answer: "Yes, instant online booking available." },
  { question: "Are drivers verified?", answer: "Yes, professional and background-verified chauffeurs." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate one-way travel supported." },
  { question: "Are AC vehicles provided?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Is support available 24/7?", answer: "Yes, round-the-clock customer assistance available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Kulkarni",
    feedback:
      "Booked one-way cab from Pune to Mumbai. Affordable and punctual service. No return charges saved cost.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Reliable one-way corporate travel. Professional driver and clean vehicle.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Sneha Patil",
    feedback:
      "Very smooth highway journey. AC car was comfortable and driver polite.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Aditya Joshi",
    feedback:
      "Transparent pricing and quick online booking. Highly recommended.",
    rating: 5
  },
  {
    id: 5,
    name: "Ms. Kavita Deshmukh",
    feedback:
      "Great experience for weekend travel. Budget-friendly and safe journey.",
    rating: 5
  }
];







































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Pune",
  "image": "https://lotuscab.com/assets/images/one-way-cab-pune.jpg",
  "description": "Book One Way Cab in Pune with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for airport transfers, family trips, corporate travel, weekend trips, local trips, and outstation rides. Affordable per km rates and same-day options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "710"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "120",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/one-way-cab-pune"
  }
};











  return (
    <div>
      

<Helmet>
  <title>One Way Cab Pune | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable One Way Cab in Pune with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for airport transfers, family trips, corporate travel, weekend trips, local & outstation trips. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune One Way Cab, AC One Way Cab Pune, Sedan One Way Cab Pune, SUV One Way Cab Pune, Luxury One Way Cab Pune, Family Trip One Way Cab Pune, Corporate One Way Cab Pune, Airport Pickup One Way Cab Pune, Airport Drop One Way Cab Pune, Online Cab Booking One Way Pune, Mini Bus One Way Cab Pune, Chauffeur Driven One Way Cab Pune, Budget One Way Cab Pune, Same Day One Way Cab Pune, Outstation One Way Cab Pune, Per Km Rate One Way Cab Pune, Weekend Trip One Way Cab Pune, Local Trip One Way Cab Pune, Best One Way Cab Pune, Group Travel One Way Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabpune;